import React from "react";
import Link from "next/link";

import { MenuItem } from "custom-types/MenuItem";
import { MenuItemV2 } from "custom-types/MenuItemV2";
import { VariantWithDeliveryInfo } from "custom-types/Variant";
import { getMenuItemUrl } from "utils/menuItemUrl";

import Button from "components/botanic/Button";

import { AddToBagButton } from "./AddToBagButton";

type MenuItemCardActionsProps = {
  menuItem: MenuItem | MenuItemV2 | VariantWithDeliveryInfo;
  onClick?: () => void;
  viewDetailsOnClick?: () => void;
  onMenuItemReserved?: () => void;
  splitClickEventName?: string;
  merchandisingCampaignId?: number;
};

export const MenuItemCardActions: React.FC<MenuItemCardActionsProps> = ({
  menuItem,
  onClick = () => {},
  viewDetailsOnClick = () => {},
  onMenuItemReserved = () => {},
  splitClickEventName,
  merchandisingCampaignId,
}) => {
  const menuItemUrl = getMenuItemUrl(menuItem, menuItem.id);
  return menuItem.onlineFulfillmentEnabled ? (
    <AddToBagButton
      defaultVariantId={menuItem.id}
      menuItem={menuItem}
      onClick={onClick}
      onReservation={onMenuItemReserved}
      splitClickEventName={splitClickEventName}
      merchandisingCampaignId={merchandisingCampaignId}
    />
  ) : (
    <Link href={menuItemUrl} passHref legacyBehavior>
      <Button
        variant="tertiary"
        size="small"
        onClick={viewDetailsOnClick}
        style={{ paddingBottom: 6, paddingTop: 6 }}
        href={menuItemUrl}
        data-testid="view-details-button"
      >
        view details
      </Button>
    </Link>
  );
};
